module.exports = __webpack_public_path__ + "img/messenger-logo.0008a6fb.svg";